import { SVGProps } from "react";

const EditFormIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-editar"
      {...props}
    >
      <path
        d="M16.303 4.30295C17.2403 3.36569 18.7599 3.36569 19.6972 4.30295C20.6344 5.24021 20.6344 6.7598 19.6972 7.69706L18.7457 8.64853L15.3516 5.25442L16.303 4.30295Z"
        fill="white"
      />
      <path
        d="M13.6545 6.95148L3.6001 17.0059V20.4H6.99421L17.0486 10.3456L13.6545 6.95148Z"
        fill="white"
      />
    </svg>
  );
};

export default EditFormIcon;
